import React from 'react'
import { ContentWidthControl } from 'src/editor/shared/settings/controls/content-width-control'
import { WebsiteLayoutSettings } from 'src/shared/types/website-settings-types'

interface WebsiteLayoutGroupProps {
  layout: WebsiteLayoutSettings
  updateLayout: <Key extends keyof WebsiteLayoutSettings>(
    prop: Key,
  ) => (value: WebsiteLayoutSettings[Key]) => void
}

export const WebsiteLayoutGroup = ({
  layout,
  updateLayout,
}: WebsiteLayoutGroupProps) => {
  return (
    <ContentWidthControl
      contentWidth={layout.contentWidth}
      update={updateLayout('contentWidth')}
    />
  )
}
